<template>
  <div v-if="ativo!=undefined">
    <div class="">
      <div>
        <DxButton 
          icon="close" 
          type="danger" 
          text="Remover Rack da posição" 
          @click="remover_rack"/> <br><br>
        <br>
        <span v-if="ativo.cd_tipo_item == 1" class="span_p_sonda">{{ ativo.nm_posicao_ativo }}</span><br><br>
        <span class="span_p_sonda">Descrição:          </span>{{ ativo.nm_descricao }}<br>
        <span class="span_p_sonda">Número de série:    </span>{{ ativo.nm_serial_number }}<br>
        <span class="span_p_sonda">Chave:              </span>{{ ativo.nm_chave }} <br>
        <span class="span_p_sonda">Fábricante:         </span>{{ ativo.nm_fabricante }}<br>
        <span class="span_p_sonda">Quantidade de Us:   </span>{{ ativo.qt_us }}<br>
        <span class="span_p_sonda">Cliente:            </span>{{ ativo.nm_cliente }} <br>
        <span class="span_p_sonda">Proprietário:       </span>{{ ativo.nm_proprietario }} <br>
        <span class="span_p_sonda">Data de instalação: </span>{{ ativo.dt_instalacao }} <br>
        <span class="span_p_sonda">Mudança:            </span>{{ ativo.cd_mudanca }} <br>
        <span class="span_p_sonda">Observação:         </span>{{ ativo.nm_observacao }} <br>
      </div>
      <br>
      <fase_localizacao :ativo_pai="ativo"></fase_localizacao>
    </div>
  </div>
</template>
<script>
import api from '@/api/api'
import DxButton from 'devextreme-vue/button'
import fase_localizacao from './fase_localizacao.vue';
import notify from 'devextreme/ui/notify'
export default{
    props:{
        ativo: Object,
    },
    data() {
        return {
          ativos: []
        };
    },
    components:{
      fase_localizacao,DxButton
    },
    methods:{
      async remover_rack(){
        var resp = await api.get('remove_ativo_posicao_rack', [this.ativo.cd_ativo])
        if (resp.Code == 0 || resp.code == 0) {
            notify({ message: resp.Message, type: 'success', displayTime: 3500, animation: { show: { type: 'fade', duration: 400, from: 0, to: 1, }, hide: { type: 'fade', duration: 40, to: 0 }, }, }, { position: 'bottom center' })
        }
        if (resp.Code == 1 || resp.code == 1) {
            notify({ message: resp.Message, type: 'error', displayTime: 3500, animation: { show: { type: 'fade', duration: 400, from: 0, to: 1, }, hide: { type: 'fade', duration: 40, to: 0 }, }, }, { position: 'bottom center' })
        }
      }
    }
}
</script>
<style>
.infos_ativo_sonda{
  display: flex;
  align-items: center;
}
.span_p_sonda{
  margin-right: 10px;
  color: rgb(0, 0, 0);
  font-weight: bold;
}
.div_imagem{
    width: auto;
    object-fit: contain;
    max-height: 450px;
}
.div_imagem_vazio{
    display: flex;
    align-items: center;
    width: 100%;
    max-height: 200px; 
    overflow: hidden;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  width: 100%;
  height: 130vh;
}
.modal-content {
    background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 900px;
  height: auto;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content img {
  max-width: 100%;
  max-height: 70vh;
}
</style>